import React, { useEffect, useState } from "react";

import styles from "./ChannelsSection.module.scss";
import modal  from "./VideoCommentsBar.module.scss";

import { getRecentVideoComments ,
         RecentVideoCommentsResult } from "../../../backendServices/moderationManagment/api_videoComments";

const STATUS_LABEL: Record<string, string> = { approved: 'Publié', pending: 'À valider', rejected: 'Refusé' };
const REFRESH_MS = 60_000;

const when = (d: Date | null) =>
  d && !isNaN(d.getTime()) ? d.toLocaleString('fr-FR', { dateStyle: 'short', timeStyle: 'short' }) : '';

/**
 * Tuile de l'onglet Vidéos du Dashboard : nouveaux commentaires du jour et des 7
 * derniers jours, et bouton qui bascule l'onglet sur la liste des commentaires
 * (CommentsPanel), le bouton restant allumé tant qu'elle est ouverte.
 */
const RecentCommentsKpi: React.FC<{ adminId: number | undefined; open: boolean; onToggle: () => void }> = ({ adminId, open, onToggle }) => {
  const [ data , setData ] = useState<RecentVideoCommentsResult | null>(null);

  useEffect(() => {
    if (!adminId) return;
    let cancelled = false;
    const load = () => getRecentVideoComments(adminId).then(r => { if (!cancelled) setData(r); });
    load();
    const timer = window.setInterval(load, REFRESH_MS);
    return () => { cancelled = true; window.clearInterval(timer); };
  }, [adminId]);

  return (
    <div className={styles.kpi}>
      <span className={styles.kpiLabel}>Nouveaux commentaires</span>
      <span className={styles.kpiValue}>{data && !data.error ? data.today : '–'}</span>
      <span className={styles.kpiMuted}>
        {data?.error ? <span style={{ color: '#d9534f' }}>{data.error}</span>
                     : data ? `aujourd'hui · ${data.week} sur 7 jours` : 'chargement…'}
      </span>
      <button type="button" className={`${modal.button} ${open ? modal.buttonOn : ''}`} aria-pressed={open}
              disabled={!data?.week && !open} onClick={onToggle}>
        Lister les commentaires
      </button>

    </div>
  );
};

export default RecentCommentsKpi;
